import React from 'react';
import { UseFormRegisterReturn, FieldError } from 'react-hook-form';
import { FormattedMessage, defineMessages } from 'react-intl';

import * as yup from 'yup';

import { BaseFormInputProps, Input, InputState, InputType } from '../Input/Input';

export const FORM_INPUT_CURRENCY = 'currency';

export type FormFieldsCurrency = {
  [FORM_INPUT_CURRENCY]: string;
};

export type Props = BaseFormInputProps & UseFormRegisterReturn & {
  error?: FieldError;
  isDisabled?: boolean;
  value: string;
};

export type FormInputCurrencyErrors = 'currencyEmptyError';

export const currencyRequiredValidationSchema = yup.string().required('currencyEmptyError');

const messages = defineMessages({
  currency: {
    id: 'src.components.FormInputCurrency.currency',
    defaultMessage: 'Currency',
  },
  currencyEmptyError: {
    id: 'src.components.FormInputCurrency.currencyEmptyError',
    defaultMessage: 'Currency is a required field',
  },
});

export const FormInputCurrency = React.memo(React.forwardRef((
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement | HTMLTextAreaElement>,
) => {
  const {
    isDisabled,
    error,
    value,
    ...rest
  } = props;

  return (
    <Input
      label={<FormattedMessage {...messages.currency} />}
      inputType={InputType.Input}
      state={
        isDisabled && InputState.Disabled
        || error && InputState.Error
        || undefined
      }
      errorMessage={
        error
        && <FormattedMessage {...messages[error?.message as FormInputCurrencyErrors]} />
      }
      value={value}
      {...rest}
      ref={ref}
    />
  );
}));

FormInputCurrency.displayName = 'FormInputCurrency';
